"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../../utils/constants");
var muiCamera16 = {
    paths: [
        {
            path: 'M2,4 L2,12.0001377 L14,12.0001377 L14,4 L11.0956207,4 L10.0809757,2 L5.88346428,2 L4.90075931,4 L2,4 Z M3.65507718,2 L4.34497953,0.595911561 C4.50668996,0.266798694 4.94176518,0 5.3018322,0 L10.6449363,0 C11.011681,0 11.4416774,0.261551579 11.6113057,0.595911561 L12.3236314,2 L14.6633689,2 C15.4015699,2 16,2.5950887 16,3.33007479 L16,12.6700629 C16,13.404643 15.411576,14.0001377 14.6633689,14.0001377 L1.33663106,14.0001377 C0.598430109,14.0001377 0,13.405049 0,12.6700629 L0,3.33007479 C0,2.59549477 0.588423967,2 1.33663106,2 L3.65507718,2 Z M8,10.5 C6.34314575,10.5 5,9.15685425 5,7.5 C5,5.84314575 6.34314575,4.5 8,4.5 C9.65685425,4.5 11,5.84314575 11,7.5 C11,9.15685425 9.65685425,10.5 8,10.5 Z M8,8.5 C8.55228475,8.5 9,8.05228475 9,7.5 C9,6.94771525 8.55228475,6.5 8,6.5 C7.44771525,6.5 7,6.94771525 7,7.5 C7,8.05228475 7.44771525,8.5 8,8.5 Z',
            fill: constants_1.defaultFill,
        },
    ],
    title: 'Camera',
    width: 16,
    height: 14,
};
var muiCamera24 = {
    paths: [
        {
            path: 'M2,4.99975586 L2,17.9997559 L22,17.9997559 L22,4.99975586 L16.7146826,4.99975586 L15.3465523,2 L8.61018015,2 L7.32083765,4.99975586 L2,4.99975586 Z M6.00355252,2.99975586 L6.89874004,0.917032285 C7.11642583,0.410569339 7.74336748,0 8.29240501,0 L15.6330709,0 C16.185085,0 16.8191867,0.409151006 17.0508215,0.917032285 L18.0007112,2.99975586 L22.9993054,2.99975586 C23.5519738,2.99975586 24,3.45446479 24,3.99971606 L24,18.9997957 C24,19.5520584 23.5525308,19.9997559 22.9993054,19.9997559 L1.00069463,19.9997559 C0.448026248,19.9997559 0,19.5450469 0,18.9997957 L0,3.99971606 C0,3.44745329 0.44746922,2.99975586 1.00069463,2.99975586 L6.00355252,2.99975586 Z M12,16 C9.23857625,16 7,13.7614237 7,11 C7,8.23857625 9.23857625,6 12,6 C14.7614237,6 17,8.23857625 17,11 C17,13.7614237 14.7614237,16 12,16 Z M12,14 C13.6568542,14 15,12.6568542 15,11 C15,9.34314575 13.6568542,8 12,8 C10.3431458,8 9,9.34314575 9,11 C9,12.6568542 10.3431458,14 12,14 Z M5,9 C5.55228475,9 6,8.55228475 6,8 C6,7.44771525 5.55228475,7 5,7 C4.44771525,7 4,7.44771525 4,8 C4,8.55228475 4.44771525,9 5,9 Z',
            fill: constants_1.defaultFill,
        },
    ],
    title: 'Camera',
    width: 24,
    height: 20,
};
var muiCamera = {
    base: muiCamera16,
    smIcon: muiCamera16,
    lgIcon: muiCamera24,
};
exports.muiCamera = muiCamera;
//# sourceMappingURL=camera.js.map